import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined'
import type { FormNode } from '../../../../types/form.types'

export interface PictureElementProps {
  node: FormNode
}

export function PictureElement({ node }: PictureElementProps) {
  const h = typeof node.height === 'number' ? node.height : 100
  const content = (
    <Box
      sx={{
        border: '1px dashed',
        borderColor: 'divider',
        borderRadius: 1,
        height: h,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        bgcolor: 'action.hover',
      }}
    >
      <ImageOutlinedIcon sx={{ fontSize: 28, color: 'text.disabled' }} />
      {node.titleVisible !== false && (
        <Typography variant="caption" color="text.disabled" sx={{ fontSize: 11 }}>
          {node.title || 'Picture'}
        </Typography>
      )}
    </Box>
  )

  if (node.tooltip) {
    return <Tooltip title={node.tooltip}>{content}</Tooltip>
  }
  return content
}
